import * as React from 'react';

export default () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="30" height="30" rx="15" stroke="#858597" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5713 7.07651C14.2737 7.37751 14.125 7.77076 14.125 8.25625C14.125 8.74174 14.2737 9.13499 14.5713 9.43599C14.8688 9.737 15.2625 9.8875 15.7525 9.8875C16.2425 9.8875 16.6362 9.737 16.9338 9.43599C17.2313 9.13499 17.38 8.74174 17.38 8.25625C17.38 7.77076 17.2313 7.37751 16.9338 7.07651C16.6362 6.7755 16.2425 6.625 15.7525 6.625C15.2625 6.625 14.8688 6.7755 14.5713 7.07651ZM15.7396 25.4463C16.3992 25.4463 16.934 24.9116 16.934 24.2519V13.5157C16.934 12.856 16.3992 12.3213 15.7396 12.3213C15.08 12.3213 14.5452 12.856 14.5452 13.5157V24.2519C14.5452 24.9116 15.08 25.4463 15.7396 25.4463Z"
      fill="#858597"
    />
  </svg>
);
